<ng-container *transloco="let t">
<div class="post d-flex flex-column-fluid">
  <div class="container">
    <div class="card" style="margin-top: 15px; height: 97vh;">
      <div class="card-body p-0 esign-container">
        <div class="card-px py-20 my-10">
          @switch (status) {
            @case ('reporting') {
              <div class="alert bg-light-primary border border-primary border-dashed d-flex flex-column flex-sm-row w-100 p-5 mb-10">
                <div class="spinner-border text-primary me-4 mb-5 mb-sm-0" style="width: 2.75rem; height: 2.75rem" role="status"></div>
                <div class="d-flex flex-column pe-0 pe-sm-10">
                  <h5 class="mb-1">{{ t('portal.esign.finishingUp') }}</h5>
                  <span>{{ t('portal.esign.recordingResult') }}</span>
                </div>
              </div>
            }
            @case ('signed') {
              <div class="alert bg-light-success border border-success border-dashed d-flex flex-column flex-sm-row w-100 p-5 mb-10">
                <i class="stepper-check fas fa-check fs-2hx text-success me-4 mb-5 mb-sm-0"></i>
                <div class="d-flex flex-column pe-0 pe-sm-10">
                  <h5 class="mb-1">{{ t('portal.esign.signedTitle') }}</h5>
                  <span>{{ t('portal.esign.signedMessage') }}</span>
                </div>
              </div>
            }
            @case ('declined') {
              <div class="alert bg-light-warning border border-warning border-dashed d-flex flex-column flex-sm-row w-100 p-5 mb-10">
                <i class="fas fa-ban fs-2hx text-warning me-4 mb-5 mb-sm-0"></i>
                <div class="d-flex flex-column pe-0 pe-sm-10">
                  <h5 class="mb-1">{{ t('portal.esign.declinedTitle') }}</h5>
                  <span>{{ t('portal.esign.declinedMessage') }}</span>
                </div>
              </div>
            }
            @case ('cancelled') {
              <div class="alert bg-light-warning border border-warning border-dashed d-flex flex-column flex-sm-row w-100 p-5 mb-10">
                <i class="fas fa-times-circle fs-2hx text-warning me-4 mb-5 mb-sm-0"></i>
                <div class="d-flex flex-column pe-0 pe-sm-10">
                  <h5 class="mb-1">{{ t('portal.esign.cancelledTitle') }}</h5>
                  <span>{{ t('portal.esign.cancelledMessage') }}</span>
                </div>
              </div>
            }
            @case ('notRecorded') {
              <div class="alert bg-light-danger border border-danger border-dashed d-flex flex-column flex-sm-row w-100 p-5 mb-10">
                <i class="fas fa-exclamation-triangle fs-2hx text-danger me-4 mb-5 mb-sm-0"></i>
                <div class="d-flex flex-column pe-0 pe-sm-10">
                  <h5 class="mb-1">{{ t('portal.esign.notRecordedTitle') }}</h5>
                  <span>{{ t('portal.esign.notRecordedMessage') }}</span>
                </div>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>
</ng-container>
